import { BaseEntityDto } from '@fleet-beat/core';

export interface ProductDto extends BaseEntityDto {
  id?: string;
  object?: string;
  active?: boolean;
  created?: number;
  description?: string;
  livemode?: boolean;
  name?: string;
  type?: string;
  updated?: number;
}
